import { createSlice } from "@reduxjs/toolkit";

export interface PhaseInDetailModal {
  id: string | number;
  open: boolean;
  phaseName: string;
  activeTab: string;
  projectResponse: {
    id: number | null;
    status: string;
    name: string;
    isLocked?: boolean;
    lockedBy?: number;
    lockedByName?: string;
    updatedDate?: string;
    updatedBy?: number;
    updatedByName?: string;
    plannedStartDate?: string;
    plannedEndDate?: string;
  };
  extra: {
    status: string;
    createdAt?: string;
    createdByUserName?: string;
    startDate?: string;
    endDate?: string;
    ownerName?: string;
    phaseOnholdDate?: string;
    phaseETAResolution?: string;
    phaseOnholdReason?: string;
    ownerId?: number;
    originalPhaseOwnerName?: string;
    originalPhaseOwnerId?: number;
    reassignedReason?: string;
    phaseWeightage?: number;
  };
  allowEdit?: boolean;
  allowAdd?: boolean;
}
const initialState: { data: PhaseInDetailModal } = {
  data: {
    id: "",
    open: false,
    phaseName: "",
    activeTab: "activities",
    projectResponse: {
      id: null,
      status: "",
      name: "",
    },
    allowEdit: true,
    allowAdd: true,
    extra: {
      status: "",
    },
  },
};

export const PhaseInDetailModalSlice = createSlice({
  name: "PhaseInDetailModalSlice",
  initialState,
  reducers: {
    updatePhaseInDetailModalSlice(state, action) {
      state.data = { ...state.data, ...action.payload };
    },
    resetPhaseInDetailModalSlice(state) {
      state.data = initialState.data;
    },
  },
});

export const { updatePhaseInDetailModalSlice, resetPhaseInDetailModalSlice } =
  PhaseInDetailModalSlice.actions;
